import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "m24 10.685-.669.493.236-.825-.65-.521.816-.018L24 9l.268.814.815.018-.65.52.236.826zm2.18.466-.811.178.55-.658-.38-.74.751.316.576-.635-.087.853.738.347-.806.212-.12.85zm.99 1.15.813.168.082.827.455-.727.822.134-.532-.618.426-.743-.784.346-.559-.594.048.83zm1.928 2.11-.675-.484.857-.03.295-.78.268.77.858.003-.692.506.235.781-.696-.457-.712.48zm-.187 1.513.42.717-.56.614.845-.148.45.7.103-.809.838-.18-.782-.352.068-.813-.586.592zm-.269 2.85-.092-.826.597.617.776-.303-.393.715.572.639-.84-.175-.422.697-.126-.823-.833-.208zm-1.24.874-.251.792-.831-.005.676.528-.22.804.67-.465.695.501-.262-.816.65-.493-.832-.04zm-2.287 1.704.552-.621-.06.856.744.374-.793.187-.093.852-.431-.74-.801.151.527-.644-.402-.758zm-1.472-.343-.757.343-.552-.621.059.856-.744.374.794.187.092.852.432-.74.8.151-.527-.644zm-2.793-.57.83-.004-.675.528.22.804-.67-.465-.696.501.262-.816-.649-.493.832-.04.294-.806zm-.73-1.332-.762-.334.092-.825-.596.617-.776-.303.392.715-.571.639.839-.175.423.697.126-.823zm-1.45-2.466.56.614-.846-.148-.45.7-.103-.809-.837-.18.781-.352-.067-.813.586.592.795-.321zm.494-1.441-.261-.789.675-.484-.858-.03-.294-.78-.269.77-.857.003.691.506-.235.781.696-.457zm.853-2.73-.082.826-.455-.727-.822.134.533-.618-.426-.743.784.346.558-.594-.047.83.77.378zm1.392-.597.411-.722.812.178-.552-.658.382-.74-.752.316-.575-.635.086.853-.737.347.805.212z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M16 0v16H.003v-.017c-.033-2.492.2-5.316.863-8.108 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M4.288 2.403 8 6.114 14.065.05A57 57 0 0 1 16 0v1.886L9.886 8 16 14.114V16h-1.886L8 9.886 1.886 16H.003v-.017q-.013-.923.027-1.898L6.114 8 2.467 4.353a9 9 0 0 1 1.821-1.95",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M14.555.031Q15.276.007 16 0L8.472 7.529l-.708-.708zM3.308 3.307l4.22 4.222-.706.707-4.157-4.157c.194-.26.408-.52.643-.772M.003 16v-.003L7.53 8.47l.707.708L1.414 16zm8.469-7.529.707-.707L16 14.586V16z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M10 .399V16H6V1.372q.168-.075.342-.143C7.272.875 8.544.6 10 .4",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M1.529 6H16v4H.442q.172-1.061.424-2.125S1.035 7.072 1.53 6",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M9.334.498V16H6.667V1.114C7.403.867 8.312.662 9.334.498",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M1.246 6.667H16v2.666H.558q.135-.728.308-1.458s.102-.487.38-1.208",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagCok = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagCok_default = SvgFlagCok;

export { FlagCok_default as default };
